var React = require('react');

function Home (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10,18.5H3.9v-8.2H0L11.5,0L23,10.4h-3.9v8.2h-6.1v-6.1H10V18.5z M4.9,17.5H9v-6.1h5.1v6.1h4.1V9.4h2.3l-8.9-8l-8.9,8h2.3\n\tV17.5z"}));
}

Home.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 23 18.5","style":{"enableBackground":"new 0 0 23 18.5"},"xmlSpace":"preserve"};

module.exports = Home;

Home.default = Home;
